/**
 * Single source of truth for the scroll-driven assembly story.
 *
 * TUNING — Länge der gesamten Scroll-Story:
 *   STORY_VH ändern (empfohlen 700–900). Alles andere (Section-Höhen,
 *   Kamera-Keyframes, Bauphasen-Fenster) leitet sich automatisch daraus ab.
 *
 * TUNING — Dramaturgie / Anteile der einzelnen Bauphasen:
 *   CHAPTER_WEIGHTS anpassen (müssen in Summe 1 ergeben).
 */
export const STORY_VH = 800;

export const CHAPTER_WEIGHTS = {
  hero: 0.15, // 0 – 15%: Teile schweben elegant, Form angedeutet
  material: 0.2, // 15 – 35%: Material & Struktur
  design: 0.2, // 35 – 55%: Design & Farben
  sleeves: 0.2, // 55 – 75%: Ärmel & Kragen
  final: 0.15, // 75 – 90%: Finaler Zusammenbau
  hero_final: 0.1, // 90 – 100%: Produkt-Hero
};

const order = ['hero', 'material', 'design', 'sleeves', 'final', 'hero_final'];

function computeBreakpoints() {
  const points = { hero_start: 0 };
  let cursor = 0;
  order.forEach((key) => {
    cursor += CHAPTER_WEIGHTS[key];
    points[`${key}_end`] = cursor;
  });
  return points;
}

// { hero_start: 0, hero_end: 0.15, material_end: 0.35, design_end: 0.55,
//   sleeves_end: 0.75, final_end: 0.9, hero_final_end: 1 }
export const BREAKPOINTS = computeBreakpoints();

export function chapterHeightVh(key) {
  return STORY_VH * CHAPTER_WEIGHTS[key];
}

export const CHAPTER_ORDER = order;
